var layout_default = {
  "layout": "IZDV9",
  "cell": "iz1uR"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
